import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import Button from '../../../../Button'

import * as styles from './FooterActions.module.css'

import ForwardIcon from '../../../../../icons/forward.svg'
import ReplyIcon from '../../../../../icons/reply.svg'
import ReplyAllIcon from '../../../../../icons/reply-to-all.svg'

function FooterActions({
  canReply,
  className = styles.FooterActions,
  disabled,
  onClickForward,
  onClickReply,
  onClickReplyAll,
}) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return canReply ? (
    <div className={className}>
      <Button.Text
        beforeIconProps={{ Icon: ReplyIcon }}
        disabled={disabled}
        text={
          !isMobileScreenSize
            ? t('EmailProfile.MessageFooterActionReplyKey')
            : null
        }
        tooltip={t('EmailProfile.MessageFooterActionReplyTooltipKey')}
        onClick={onClickReply}
      />
      <Button.Text
        beforeIconProps={{ Icon: ReplyAllIcon }}
        disabled={disabled}
        text={
          !isMobileScreenSize
            ? t('EmailProfile.MessageFooterActionReplyToAllKey')
            : null
        }
        tooltip={t('EmailProfile.MessageFooterActionReplyToAllTooltipKey')}
        onClick={onClickReplyAll}
      />
      <Button.Text
        beforeIconProps={{ Icon: ForwardIcon }}
        disabled={disabled}
        text={
          !isMobileScreenSize
            ? t('EmailProfile.MessageFooterActionForwardKey')
            : null
        }
        tooltip={t('EmailProfile.MessageFooterActionForwardTooltipKey')}
        onClick={onClickForward}
      />
    </div>
  ) : null
}

export default FooterActions
